module.exports = "<div class=\"popup-modal\">\n    <div class=\"popup-header\">{{data.title}}</div>\n    <div class=\"popup-content\">\n        <template #container></template>\n    </div>\n    <div class=\"popup-footer\" [ngClass]=\"data.footerClasses || []\">\n        <button *ngFor=\"let button of data.buttons\" class=\"btn btn-default\"\n            [ngClass]=\"button.cssClasses || []\" (click)=\"onClick(button)\">{{button.text}}</button>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/dialogs/container-dialog/container-dialog.component.html
// module id = 1907
// module chunks = 0